/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdc_Field_QuantityInputs */

const vi_pdc_field_quantity = /** @type {(inputs: Pdc_Field_QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng chuyển`)
};

/**

* @param {Pdc_Field_QuantityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pdc_field_quantity = /** @type {((inputs?: Pdc_Field_QuantityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdc_Field_QuantityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pdc_field_quantity(inputs)
});